<template>
    <v-layout align-center justify-center>
        <v-flex shrink class="text-center">
            <h1 class="title mt-10">Вы не авторизованы смотреть эту страницу!</h1>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'not-found',
  }
</script>
